'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useParams } from 'next/navigation';
import React, { useEffect, useState, useTransition } from 'react';
import { useLocale } from 'next-intl';
import localization from '@/i18n/localization';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePathname, useRouter } from '@/i18n/routing';
import { Media } from '@/components/Media';
import { Menu } from "lucide-react";
import { SideMenu } from './side-menu';
import { MenuBar } from './menu-bar';
export const HeaderClient = t0 => {
  const $ = _c(36);
  const {
    header
  } = t0;
  usePathname();
  const {
    logo,
    navLinks,
    scrolledLogo,
    sociallinks
  } = header;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 0);
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== navLinks) {
    t3 = navLinks || [];
    $[2] = navLinks;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let T0;
  let menuItems;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] !== isScrolled || $[5] !== logo || $[6] !== scrolledLogo || $[7] !== t3) {
    menuItems = t3.map(_temp2).filter(_temp3);
    t5 = "light";
    t6 = `px-8 md:px-12 lg:px-16 mx-auto bg-background text-primary z-20 ${isScrolled ? "py-2 fixed top-0 left-0 right-0 opacity-95" : "py-4"} flex justify-end items-center gap-2 transition-all duration-300 ${isScrolled ? "shadow-md" : ""}`;
    let t8;
    if ($[14] !== isScrolled || $[15] !== logo || $[16] !== scrolledLogo) {
      t8 = isScrolled && scrolledLogo ? <Media resource={scrolledLogo} imgClassName="h-12 !w-auto" /> : logo && <Media resource={logo} imgClassName={isScrolled ? "h-12 !w-auto" : "h-16 !w-auto"} />;
      $[14] = isScrolled;
      $[15] = logo;
      $[16] = scrolledLogo;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    if ($[18] !== t8) {
      t7 = <Link href="/" className="me-auto">{t8}</Link>;
      $[18] = t8;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    T0 = MenuBar;
    t4 = menuItems.map(_temp4);
    $[4] = isScrolled;
    $[5] = logo;
    $[6] = scrolledLogo;
    $[7] = t3;
    $[8] = T0;
    $[9] = menuItems;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    T0 = $[8];
    menuItems = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[20] !== T0 || $[21] !== t4) {
    t8 = <T0 items={t4} />;
    $[20] = T0;
    $[21] = t4;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsMenuOpen(true);
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <button onClick={t9} className="flex gap-2 items-center font-light text-xs" aria-label="Open menu"><span>القائمة</span><Menu className="h-6 w-6" /></button>;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = sociallinks;
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setIsMenuOpen(false);
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isMenuOpen || $[27] !== menuItems || $[28] !== t11) {
    t13 = <SideMenu items={menuItems} sociallinks={t11} isOpen={isMenuOpen} onClose={t12} />;
    $[26] = isMenuOpen;
    $[27] = menuItems;
    $[28] = t11;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8) {
    t14 = <header data-theme={t5} className={t6}>{t7}{t8}{t10}{t13}</header>;
    $[30] = t13;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export function LocaleSwitcher() {
  const $ = _c(10);
  const locale = useLocale();
  const router = useRouter();
  const [, startTransition] = useTransition();
  const pathname = usePathname();
  const params = useParams();
  let t0;
  if ($[0] !== params || $[1] !== pathname || $[2] !== router || $[3] !== startTransition) {
    t0 = function onSelectChange(value) {
      startTransition(() => {
        router.replace({
          pathname,
          params
        }, {
          locale: value
        });
      });
    };
    $[0] = params;
    $[1] = pathname;
    $[2] = router;
    $[3] = startTransition;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const onSelectChange = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SelectTrigger className="w-auto text-sm bg-transparent gap-2 pl-0 md:pl-3 border-none"><SelectValue placeholder="Theme" /></SelectTrigger>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SelectContent>{localization.locales.sort(_temp5).map(_temp6)}</SelectContent>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== locale || $[8] !== onSelectChange) {
    t3 = <Select onValueChange={onSelectChange} value={locale}>{t1}{t2}</Select>;
    $[7] = locale;
    $[8] = onSelectChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp6(locale_0) {
  return <SelectItem value={locale_0.code} key={locale_0.code}>{locale_0.label}</SelectItem>;
}
function _temp5(a, b) {
  return a.label.localeCompare(b.label);
}
function _temp(subLink) {
  const subLinkData = subLink.link;
  const subUrl = subLinkData?.url || (subLinkData?.reference?.value && typeof subLinkData.reference.value !== "number" ? `/${subLinkData.reference.value.slug || ""}` : "#");
  return {
    id: subLink.id || `sub-${Math.random()}`,
    title: subLinkData?.label || "",
    href: subUrl
  };
}
function _temp2(navLink) {
  const mainLinkData = navLink.mainLink?.[0]?.link;
  const mainUrl = mainLinkData?.url || (mainLinkData?.reference?.value && typeof mainLinkData.reference.value !== "number" ? `/${mainLinkData.reference.value.slug || ""}` : "#");
  return {
    id: navLink.id || `nav-${Math.random()}`,
    title: mainLinkData?.label || "",
    href: mainUrl,
    icon: mainLinkData?.fiIcon || "",
    expandable: (navLink.subLinks || []).length > 0,
    items: (navLink.subLinks || []).map(_temp)
  };
}
function _temp3(item) {
  return item.title;
}
function _temp4(item_0) {
  return {
    icon: item_0.icon,
    label: item_0.title,
    href: item_0.href,
    gradient: "radial-gradient(circle, rgba(59,130,246,0.15) 0%, rgba(37,99,235,0.06) 50%, rgba(29,78,216,0) 100%)",
    iconColor: "text-primary"
  };
}